module.exports = __webpack_public_path__ + "img/greyCreated.63cc5298.svg";